import { Typography } from 'antd';
import { ContainerOutlined } from '@ant-design/icons';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';

type Props = {
    open: boolean;
    onConfirm: () => void;
    onClose: () => void;
    isArchiving?: boolean;
    customersUsingCount?: number;
};

const ArchiveChargeModal = ({ open, isArchiving, customersUsingCount, onConfirm, onClose }: Props) => {
    const isChargeInUse = !!customersUsingCount && customersUsingCount > 0;

    const confirmButtonText = isChargeInUse ? 'Archive anyway' : 'Archive';
    const message = isChargeInUse
        ? `This charge is applied to ${customersUsingCount} customer${
              customersUsingCount === 1 ? '' : 's'
          }. Archiving it will remove it from their records too. Are you sure you want to archive it?`
        : 'Are you sure you want to archive the additional charge?';

    return (
        <ConfirmationModal
            width={500}
            open={open}
            icon={<ContainerOutlined />}
            title="Archive Additional Charge"
            confirmButtonText={confirmButtonText}
            confirmationButtonLoading={isArchiving}
            onCancel={onClose}
            onConfirm={onConfirm}
            content={<Typography.Text>{message}</Typography.Text>}
        />
    );
};

export default ArchiveChargeModal;
